import React, {PureComponent} from "react"
import styled from "styled-components"
import {Deal} from "@irati/types"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {Checkbox} from "@irati/ui/src/FormItem"
import Form from "@irati/ui/src/Form"
import Validation from "@irati/utils/validation"
import {FormatMessage} from "@irati/utils/lang/types"

const Container = styled.div`
  margin-bottom: 40px;
`

const CheckboxContainer = styled.div`
  margin-top: 30px;
  .form-group {
    margin-bottom: 0px;
  }
`

interface Props extends InjectIntl {
  deal: Deal
}

interface State {
  agree: boolean
}

const agreeSchema = (formatMessage: FormatMessage) =>
  Validation.bool().oneOf([true], formatMessage({id: "perks.components.productForms.timeLimited.agree.error"}))

class TimeLimitedDeal extends PureComponent<Props, State> {
  state = {
    agree: false
  }

  handleChange = () => this.setState(({agree}) => ({agree: !agree}))

  render() {
    return (
      <Container>
        <FormattedMessage id="perks.components.productForms.timeLimited.body" />
        <CheckboxContainer>
          <Form>
            <Checkbox
              name="agreeTo24HoursLimit"
              validation={agreeSchema(this.props.formatMessage)}
              checked={this.state.agree}
              onChange={this.handleChange}>
              <FormattedMessage id="perks.components.productForms.timeLimited.agree.label" />
            </Checkbox>
          </Form>
        </CheckboxContainer>
      </Container>
    )
  }
}

export default injectIntl(TimeLimitedDeal)
